//
//
//
//

export default {
  name: 'DpTableMessage',
};
